'use client';

import type { JSX } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';

interface IVideoStepProps {
  hasVideo: boolean;
}

const PRESENT_DESCRIPTION =
  'Source video is on Snow Titan and ready. Clips are cropped from it once you approve them in the app triage flow.';

const MISSING_DESCRIPTION =
  'No source video on Snow Titan yet. Find this title online, download the file, and drop it onto Snow Titan at the matching vault path so clips can be cropped from it.';

export function VideoStep({ hasVideo }: IVideoStepProps): JSX.Element {
  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={hasVideo} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Video"
          description={hasVideo ? PRESENT_DESCRIPTION : MISSING_DESCRIPTION}
        />
      )}
    />
  );
}
